import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import {Box, FormControl, InputLabel, LinearProgress, MenuItem, Select, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';


const Impression = ({Show,toggleImpression,type}) => {

    const userData = useSelector(state => state.userData)
    const apitoken = userData.apitoken;
    const id = userData.id;
    const apiUrl = process.env.REACT_APP_API_URL;


    const [chargement,setChargement] = useState(false);

    const [listVendeurs, setlistVendeurs] = useState([]);
    const [listPreVendeurs, setlistPreVendeurs] = useState([]);

    const [valVendeurs, setvalVendeurs] = useState('');

    const dateVenteField = useRef('')

    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');

    const todayDate = `${year}-${month}-${day}`;
  
    const [selectedDate, setSelectedDate] = useState(todayDate);


    const navigate = useNavigate();

            const handleVendeurChange = (event) => {
        setvalVendeurs(event.target.value);
        };

            const handleDateChange = (event) => {
      setSelectedDate(event.target.value);
    };

 

    const printTicket = async () => {
      setChargement(true);
      try {

      const response =  await axios.post(`${apiUrl}impression/new/${id}/${apitoken}/${selectedDate}/${valVendeurs}`,

        {
          timeout: 20000,
        }
      );



      }
      catch (error) {
        // navigate('/');    
      } 
      setChargement(false);
       toggleImpression();
    }

    const printRecap = async () => {
      setChargement(true);
      try {
          const response =  await axios.get(`${apiUrl}impression/recap/${id}/${apitoken}/${selectedDate}/${valVendeurs}`,{
        responseType: 'blob',
      });
      

            // Créez un lien pour télécharger le PDF
      const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download',`Recap ventes.pdf`);
      document.body.appendChild(link);
      link.click();
      }

      catch (error) {
        console.error('Error generating fsortie:', error);
      }
      setChargement(false);
       toggleImpression();
    }

      const handlePrint =  () => {

        if(type === "tickets"){
            printTicket();
        }
        else if(type === "recap"){
            printRecap();
        }
      }

          const getVendeurs=async () => {
            try {
            const response = await axios.post(`${apiUrl}vendeurs/${id}/${apitoken}`,
              {
                timeout: 20000,
              }
            );
            setlistVendeurs(response.data);
            }
         catch (error) {
          navigate('/');    
        }
        }

        useEffect(() => {
          getVendeurs();
        }, [Show]);

  

            const getPrevendeurs=async () => {
            try {
            const response = await axios.post(`${apiUrl}prevendeurs/${id}/${apitoken}`,
              {
                timeout: 20000,
              }
            );
            setlistPreVendeurs(response.data);
            }
         catch (error) {
          navigate('/');    
        }
        }

        useEffect(() => {
          getPrevendeurs();
        }, [Show]);


  return (
    <Dialog open={Show} onClose={toggleImpression}>
      <DialogTitle>Impression</DialogTitle>
      <DialogContent>


<FormControl fullWidth margin="dense">

        { type === "tickets" ?
        
        <>
          <InputLabel id="demo-simple-select-label">Prévendeurs</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          fullWidth
          id="demo-simple-select"
          value={valVendeurs}
          label="Prévendeurs"
          onChange={handleVendeurChange}
        >
          {listPreVendeurs.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.nom}
         </MenuItem>
       ))}
          </Select>
        </>

        :

        <>

        <InputLabel id="demo-simple-select-label">Vendeurs</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          fullWidth
          id="demo-simple-select"
          value={valVendeurs}
          label="Vendeurs"
          onChange={handleVendeurChange}
        >
          {listVendeurs.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.nom}
         </MenuItem>
       ))}
          </Select>
        </>
      
      }
          



          </FormControl>

        <TextField sx={{ marginTop: '20px' }}
          margin="dense"
          label="Date de vente"
          type="date"
          fullWidth
          value={selectedDate}
          onChange={handleDateChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={toggleImpression}>Annuler</Button>
        <Button onClick={handlePrint} variant="contained" color="primary">
          Imprimer
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Impression